var map = {
	"./apple-laurel-da-DK.svg": 48148,
	"./apple-laurel-de-DE.svg": 23442,
	"./apple-laurel-en-GB.svg": 57574,
	"./apple-laurel-en-US.svg": 10654,
	"./apple-laurel-es-ES.svg": 61759,
	"./apple-laurel-es-MX.svg": 62559,
	"./apple-laurel-fr-FR.svg": 3783,
	"./apple-laurel-it-IT.svg": 98551,
	"./apple-laurel-nb-NO.svg": 88315,
	"./apple-laurel-nl-NL.svg": 31031,
	"./apple-laurel-pl-PL.svg": 28944,
	"./apple-laurel-pt-BR.svg": 24912,
	"./apple-laurel-pt-PT.svg": 77659,
	"./apple-laurel-sv-SE.svg": 93470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74055;